import React, { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import ArticleAccess from '@fuww/library/src/Login/ArticleAccess';
import Divider from '@fuww/library/src/Login/Divider';
import EmailAccess from './EmailAccess';
import LoginWithProviderForm from './LoginWithProviderForm';
import { CaptchaProvider } from '../Captcha';
import messages from '../../lib/messages.mjs';
import DynamicAbTest from '../DynamicAbTest';

const headlineVariantKeys = [
  'paywallHeadline1',
  'paywallHeadline2',
  'paywallHeadline3',
  'paywallHeadline4',
  'paywallHeadline5',
  'paywallHeadline6',
];

const getVariantName = (
  _: React.ReactNode[],
  variant: React.ReactNode,
) => variant as string;

const ArticleAccessForm = () => {
  const [
    verifyEmailMessage, setVerifyEmailMessage,
  ] = useState<string | undefined>();
  const [conversionTracker, setConversionTracker] = useState<() => void>();
  const intl = useIntl();

  const headlineVariants = useMemo(() => (
    headlineVariantKeys.map((key) => intl.formatMessage(messages[key]))),
  [intl],
  );

  const getConversionTracker = useMemo(
    () => (tracker: () => void) => setConversionTracker(() => tracker),
    [setConversionTracker],
  );

  return verifyEmailMessage ? (
    <ArticleAccess verifyEmailMessage={verifyEmailMessage} />
  ) : (
    <ArticleAccess
      invitation={(
        <DynamicAbTest
          name="paywallHeadlineText"
          variants={headlineVariants}
          getConversionTracker={getConversionTracker}
          getVariantName={getVariantName}
        />
      )}
    >
      <CaptchaProvider>
        <EmailAccess
          setVerifyEmailMessage={setVerifyEmailMessage}
          onSubmit={conversionTracker}
        />
      </CaptchaProvider>
      <Divider
        dividerText={intl.formatMessage(messages.dividerText)}
        margin="16px 0 0"
      />
      <LoginWithProviderForm
        provider="google"
        onClick={conversionTracker}
      />
      <LoginWithProviderForm
        provider="linkedin"
        onClick={conversionTracker}
      />
    </ArticleAccess>
  );
};

ArticleAccessForm.propTypes = {};

ArticleAccessForm.defaultProps = {};

export default ArticleAccessForm;
